import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
  user: null,
  token: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuth = action.payload.isAuth;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    removeAuth: (state) => {
      state.isAuth = false;
      state.user = null;
      state.token = null;
    }
  }
});

export const { setAuth, removeAuth } = authSlice.actions;

export default authSlice.reducer;
